import React, { useCallback } from "react";
import { Button } from "semantic-ui-react";
// import useURLParams from "../../../hooks/useURLParams";

type Props = {};

const InvalidBoxContentButton = (props: Props) => {
  // const { setParam } = useURLParams();
  const setParam = (param: string, value: any) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(param, value);

    window.location.search = searchParams.toString(); // @ts-nocheck
  };
  const navigateToOrderOverviewHandler = useCallback(() => setParam("review", "false"), []);
  return (
    <Button
      content="Innehållet stämmer inte"
      size="big"
      primary
      aria-label="innehållet stämmer inte"
      icon="exclamation"
      onClick={navigateToOrderOverviewHandler}
    />
  );
};

export default InvalidBoxContentButton;
